import React from 'react';
import { withTheme } from 'styled-components';

const VerticalDivider = ({ theme }) => {
  return (
    <svg
      width="1"
      height="30"
      viewBox="0 0 1 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.5"
        x2="0.5"
        y2="30"
        stroke={theme.themeColors.controlBar.leftPanel.dividerColor}
      />
    </svg>
  );
};

export default withTheme(VerticalDivider);
